import { gql, useQuery } from "@apollo/client";

export function useGetCompanyPolicySchedules(variables = null) {
  
  return useQuery(
    gql`
      query getCompanyPolicySchedules($filter: FilterFindManyCompanyPolicyScheduleInput) {
        company_policy_schedules(filter: $filter) {
          _id
          start_date
          end_date
          policy_details {
            _id
            name
          }
          created_by_user {
            _id
            name
          }
          created_at
          updated_by_user {
            _id
            name
          }
          updated_at
        }
      }
      `,
      {
        variables: variables || undefined,
        fetchPolicy : 'network-only'
      }
    );
}

